import { getCurrentConference } from '../base/conference';
import { openDialog } from '../base/dialog';
import { getLocalParticipant } from '../base/participants';

import {
    ACCOUNTMODE, AMOUNTSECTION, CAMPAIGNRAISEDDETAILS, CHARGEDATEDATA, CLEAR_FORM_API_CACHE, CNP_PAYQUICKLY_DATA, CONFEEORDERITEM, CONVENIENCEFEEAMOUNT, CONVENIENCEFEESECTION,
    CONVENIENCEFEESELECTED, DEFAULTDONATIONAMOUNT, DONATIONAMOUNTINDEX, DONATIONAMOUNTSELECTED, DONATIONFORMDETAILS, DONATIONITEMS, DONATIONORDERITEMS,
    DONATIONSTREAM, DONATION_INFO_DATA, DONATION_MAREQUE, FINALDONATIONAMOUNTERROR, FINALDONATIONAMT, FORMGUID, FORMSETTINGS, FORM_INSTANCE_DATA, FORM_PUBLISH_STATUS, GIVENTID, GIVENT_TOKEN,
    HASINSTALLMENTERROR, HASLESSINSTALLMENTAMT, INSTALLEMENTSELECTED, INSTALLMENTCHARGE, INSTALLMENTERRORMSG,
    ISDONATIONAMOUNTEMPTY, ISDONATIONDONE, ISEVENTEXPIRED, ISINDEFINITERECURRING, ISINSTALLMENTTOUCHED,
    ISPAYSECTOUCHED, IS_ENABLED, IS_MARQUEE_CLOSED, LASTSTREAMTIME, MEETFORMDATA, MEET_DATA, MULTIDONATIONERR, MULTIDONATIONORDERITEMS,
    MULTIDONATIONVALS, MULTIPAYTOTALTAXDEDUCT, NOOFPERIODICITY, NORECURRINGOPTIONAVAILABLE, OTHERAMOUNTMINMAXERROR, PAYMENTERR, PAYMENTORDERITEM, PAYMENTORDERNO, PAYMENTSECTION,
    PAYMENTTYPEMETHOD, PERIODICITYENDDATE, RECURRINGMETHOD, RECURRINGSECTION, RECURRINGSELECTION, RENDER_POPUP_OVERLAY, RESET_CLICKANDPLEDGE, SAVE_FORM_GUID_DATA, SET_CNP_API_CACHE, SHOWASANONYMOUS,
    SHOWHIDEFORM, SHOWONETIMEPAYOPTION, STREAMOPTIONS, STREAM_INFO_DATA, TOTALDONATIONAMOUNT, TOUCHEDFIELDS, USERACCOUNTINFO, USERID, USER_FORM_DATA, VALIDATIONSECTION, WALLET_PAYMENT_RETURN
} from './actionTypes';
import { safeConferenceSendMessage } from './conferenceUtils';

const DEFAULT_STREAM_OPTIONS = {
    SPM: 1,
    SPS: 1,
    SVS: 1
};

/**
 * Normalizes stream options to numeric flags.
 *
 * @param {Object} options - Raw options payload.
 * @returns {Object}
 */
function normalizeStreamOptions(options = {}) {
    return {
        SPM: options.SPM === 0 ? 0 : 1,
        SPS: options.SPS === 0 ? 0 : 1,
        SVS: options.SVS === 0 ? 0 : 1
    };
}

/**
 * bind Meethour data for Click&Pledge
 */
export function bindMeetData(payload) {
    return {
        type: MEET_DATA,
        payload
    };
}

/**
 * bind PayQuickly data for Click&Pledge
 * @param {*} payload
 * @returns {type: string, payload: *}
 */
export function bindPayQuicklyData(payload) {
    return {
        type: CNP_PAYQUICKLY_DATA,
        payload
    };
}

/**
 * render popup overlay for Click&Pledge
 * @param {*} payload
 * @returns {type: string, payload: *}
 */
export function setPopupOverlay(payload, popupWindow) {
    return {
        type: RENDER_POPUP_OVERLAY,
        payload,
        popupWindow
    };
}

/**
 * set Mareque Data for Click&Pledge
 */
export function setMarequeData(payload) {
    return {
        type: DONATION_MAREQUE,
        payload
    };
}

/**
 * set user id for Click&Pledge
 */
export function setUserId(payload) {
    return {
        type: USERID,
        payload
    };
}

/**
 * checking if enabled or not for Click&Pledge
 */
export function isClickandPledge(payload) {
    return {
        type: IS_ENABLED,
        payload
    };
}

/**
 * set givent token for Click&Pledge
 */
export function setGiventToken(payload) {
    return {
        type: GIVENT_TOKEN,
        payload
    };
}

/**
 * bind user account data for Click&Pledge
 */
export function bindUserAccountData(payload) {
    return {
        type: USERACCOUNTINFO,
        payload
    };
}

/**
 * bind form GUID for Click&Pledge
 */
export function bindFormGUID(payload) {
    return {
        type: FORMGUID,
        payload
    };
}

/**
 * bind meet form settings for Click&Pledge
 */
export function bindMeetFormSettings(payload) {
    return {
        type: FORMSETTINGS,
        payload
    };
}

/**
 * bind givent ID for Click&Pledge
 */
export function bindGiventID(payload) {
    return {
        type: GIVENTID,
        payload
    };
}

/**
 * bind account mode for Click&Pledge
 */
export function bindAccountMode(payload) {
    return {
        type: ACCOUNTMODE,
        payload
    };
}

/**
 * bind charge date data for Click&Pledge
 */
export function bindChargeDateData(payload) {
    return {
        type: CHARGEDATEDATA,
        payload
    };
}

/**
 * bind event expiration status for Click&Pledge
 */
export function bindIsEventExpired(payload) {
    return {
        type: ISEVENTEXPIRED,
        payload
    };
}

/**
 * bind meet form data for Click&Pledge
 */
export function bindMeetFormData(payload) {
    return {
        type: MEETFORMDATA,
        payload
    };
}

/**
 * bind donation form details for Click&Pledge
 */
export function bindDonationFormDetails(payload) {
    return {
        type: DONATIONFORMDETAILS,
        payload
    };
}

// Recurring & Amount
/**
 * bind recurring section data for Click&Pledge
 */
export function bindRecurringSection(payload) {
    return {
        type: RECURRINGSECTION,
        payload
    };
}

/**
 * bind amount section data for Click&Pledge
 */
export function bindAmountSection(payload) {
    return {
        type: AMOUNTSECTION,
        payload
    };
}

/**
 * bind recurring selection for Click&Pledge
 */
export function bindRecurringSelection(payload) {
    return {
        type: RECURRINGSELECTION,
        payload
    };
}

/**
 * bind recurring method for Click&Pledge
 */
export function bindRecurringMethod(payload) {
    return {
        type: RECURRINGMETHOD,
        payload
    };
}

/**
 * bind payment type method for Click&Pledge
 */
export function bindPaymentTypeMethod(payload) {
    return {
        type: PAYMENTTYPEMETHOD,
        payload
    };
}

/**
 * bind selected donation amount for Click&Pledge
 */
export function bindDonationAmountSelected(payload) {
    return {
        type: DONATIONAMOUNTSELECTED,
        payload
    };
}

/**
 * bind donation amount index for Click&Pledge
 */
export function bindDonationAmountIndex(payload) {
    return {
        type: DONATIONAMOUNTINDEX,
        payload
    };
}

/**
 * bind donation items for Click&Pledge
 */
export function bindDonationItems(payload) {
    return {
        type: DONATIONITEMS,
        payload
    };
}

/**
 * bind number of periodicity for Click&Pledge
 */
export function bindNoOfPeriodicity(payload) {
    return {
        type: NOOFPERIODICITY,
        payload
    };
}

/**
 * bind periodicity end date for Click&Pledge
 */
export function bindPeriodicityEndDate(payload) {
    return {
        type: PERIODICITYENDDATE,
        payload
    };
}

/**
 * bind show one time payment option for Click&Pledge
 */
export function bindShowOneTimePayOption(payload) {
    return {
        type: SHOWONETIMEPAYOPTION,
        payload
    };
}

/**
 * bind no recurring option available status for Click&Pledge
 */
export function bindNoRecurringOptionAvailable(payload) {
    return {
        type: NORECURRINGOPTIONAVAILABLE,
        payload
    };
}

// Payment
/**
 * bind payment section data for Click&Pledge
 */
export function bindPaymentSection(payload) {
    return {
        type: PAYMENTSECTION,
        payload
    };
}

/**
 * bind payment order number for Click&Pledge
 */
export function bindPaymentOrderNo(payload) {
    return {
        type: PAYMENTORDERNO,
        payload
    };
}

/**
 * bind payment error for Click&Pledge
 */
export function bindPaymentError(payload) {
    return {
        type: PAYMENTERR,
        payload
    };
}

/**
 * bind touched fields for Click&Pledge
 */
export function bindTouchedFields(payload) {
    return {
        type: TOUCHEDFIELDS,
        payload
    };
}

/**
 * bind payment section touched status for Click&Pledge
 */
export function bindPaySecTouched(payload) {
    return {
        type: ISPAYSECTOUCHED,
        payload
    };
}

// Installments
/**
 * bind installment selection for Click&Pledge
 */
export function bindInstallements(payload) {
    return {
        type: INSTALLEMENTSELECTED,
        payload
    };
}

/**
 * bind installment error status for Click&Pledge
 */
export function bindInstallmentError(payload) {
    return {
        type: HASINSTALLMENTERROR,
        payload
    };
}

/**
 * bind has less installment amount status for Click&Pledge
 */
export function bindHaslessInstallmentAmt(payload) {
    return {
        type: HASLESSINSTALLMENTAMT,
        payload
    };
}

/**
 * bind installment error message for Click&Pledge
 */
export function bindInstallmentErrorMsg(payload) {
    return {
        type: INSTALLMENTERRORMSG,
        payload
    };
}

/**
 * bind installment charge value for Click&Pledge
 */
export function bindInstallmentChargeValue(payload) {
    return {
        type: INSTALLMENTCHARGE,
        payload
    };
}

/**
 * bind installment touched status for Click&Pledge
 */
export function bindIsInstallmentTouched(payload) {
    return {
        type: ISINSTALLMENTTOUCHED,
        payload
    };
}

/**
 * bind indefinite recurring status for Click&Pledge
 */
export function bindIsInDefiniteRecurring(payload) {
    return {
        type: ISINDEFINITERECURRING,
        payload
    };
}

// Convenience Fee
/**
 * bind convenience fee section for Click&Pledge
 */
export function bindConvenienceFeeSection(payload) {
    return {
        type: CONVENIENCEFEESECTION,
        payload
    };
}

/**
 * bind convenience fee amount for Click&Pledge
 */
export function bindConvenienceFeeAmount(payload) {
    return {
        type: CONVENIENCEFEEAMOUNT,
        payload
    };
}

/**
 * bind convenience fee selection for Click&Pledge
 */
export function bindConvenienceFeeSelected(payload) {
    return {
        type: CONVENIENCEFEESELECTED,
        payload
    };
}

// Donation Processing
/**
 * bind final donation amount for Click&Pledge
 */
export function bindFinalDonationAmount(payload) {
    return {
        type: FINALDONATIONAMT,
        payload
    };
}

/**
 * bind final donation amount error for Click&Pledge
 */
export function bindFinalDonationAmountError(payload) {
    return {
        type: FINALDONATIONAMOUNTERROR,
        payload
    };
}

/**
 * bind donation amount empty status for Click&Pledge
 */
export function bindIsDonationAmountEmpty(payload) {
    return {
        type: ISDONATIONAMOUNTEMPTY,
        payload
    };
}

/**
 * bind donation completion status for Click&Pledge
 */
export function bindIsDonationDone(payload) {
    return {
        type: ISDONATIONDONE,
        payload
    };
}

/**
 * bind default donation amount for Click&Pledge
 */
export function bindDefaultDonationAmount(payload) {
    return {
        type: DEFAULTDONATIONAMOUNT,
        payload
    };
}

/**
 * bind other amount min/max error for Click&Pledge
 */
export function bindOtherAmountMinMaxError(payload) {
    return {
        type: OTHERAMOUNTMINMAXERROR,
        payload
    };
}

/**
 * bind validation section for Click&Pledge
 */
export function bindValidationSection(payload) {
    return {
        type: VALIDATIONSECTION,
        payload
    };
}

/**
 * bind show/hide form status for Click&Pledge
 */
export function bindShowHideForm(payload) {
    return {
        type: SHOWHIDEFORM,
        payload
    };
}

/**
 * bind show as anonymous status for Click&Pledge
 */
export function bindShowAsAnonymous(payload) {
    return {
        type: SHOWASANONYMOUS,
        payload
    };
}

// Order Items
/**
 * bind donation order items for Click&Pledge
 */
export function bindDonationOrderItems(payload) {
    return {
        type: DONATIONORDERITEMS,
        payload
    };
}

/**
 * bind convenience fee order item for Click&Pledge
 */
export function bindConFeeOrderItem(payload) {
    return {
        type: CONFEEORDERITEM,
        payload
    };
}

/**
 * bind payment order item for Click&Pledge
 */
export function bindPaymentOrderItem(payload) {
    return {
        type: PAYMENTORDERITEM,
        payload
    };
}

/**
 * bind multi donation order items for Click&Pledge
 */
export function bindMultiDonationOrderItems(payload) {
    return {
        type: MULTIDONATIONORDERITEMS,
        payload
    };
}

/**
 * bind multi payment total tax deduction for Click&Pledge
 */
export function bindMultiPayTotalTaxDeduct(payload) {
    return {
        type: MULTIPAYTOTALTAXDEDUCT,
        payload
    };
}

/**
 * bind multi donation error for Click&Pledge
 */
export function bindMultiDonationError(payload) {
    return {
        type: MULTIDONATIONERR,
        payload
    };
}

/**
 * bind multi donation values for Click&Pledge
 */
export function bindMultiDonationVals(payload) {
    return {
        type: MULTIDONATIONVALS,
        payload
    };
}

// Campaign & Stream
/**
 * bind campaign raised details for Click&Pledge
 */
export function bindCampaignRaisedDetails(payload) {
    return {
        type: CAMPAIGNRAISEDDETAILS,
        payload
    };
}

/**
 * bind stream options for Click&Pledge
 */
export function bindStreamOptions(payload) {
    return {
        type: STREAMOPTIONS,
        payload
    };
}

/**
 * bind donation stream for Click&Pledge
 */
export function bindDonationStream(payload) {
    return {
        type: DONATIONSTREAM,
        payload
    };
}

/**
 * bind total donation amount for Click&Pledge
 */
export function bindTotalDonationAmount(payload) {
    return {
        type: TOTALDONATIONAMOUNT,
        payload
    };
}

/**
 * bind last stream time for Click&Pledge
 */
export function bindLastStreamTime(payload) {
    return {
        type: LASTSTREAMTIME,
        payload
    };
}

// Reset all clickandpledge state to default
/**
 * reset all Click&Pledge state to default
 */
export function resetClickandPledge() {
    return { type: RESET_CLICKANDPLEDGE };
}

/**
 * Cache Click&Pledge API responses for the session.
 * @param {string} cacheKey - Unique cache key for the request/params.
 * @param {*} data - Cached response data.
 * @returns {Object}
 */
export function setClickandPledgeApiCache(cacheKey, data) {
    return {
        type: SET_CNP_API_CACHE,
        cacheKey,
        data
    };
}

/**
 * Store form instance data (replaces /createforminstance API)
 */
export function setFormInstanceData(payload) {
    return {
        type: FORM_INSTANCE_DATA,
        payload
    };
}

/**
 * Save form GUID data (replaces /saveformguid API)
 */
export function saveFormGuidData(payload) {
    return {
        type: SAVE_FORM_GUID_DATA,
        payload
    };
}

/**
 * Store user form data (replaces /getuserform API)
 */
export function setUserFormData(payload) {
    return {
        type: USER_FORM_DATA,
        payload
    };
}

/**
 * Set form publish status (replaces /publishform API)
 */
export function setFormPublishStatus(payload) {
    return {
        type: FORM_PUBLISH_STATUS,
        payload
    };
}

/**
 * Save donation info data (replaces /saveinfo API)
 */
export function saveDonationInfoData(payload) {
    return {
        type: DONATION_INFO_DATA,
        payload
    };
}

/**
 * Store stream info data (replaces /getstreaminfo API)
 */
export function setStreamInfoData(payload) {
    return {
        type: STREAM_INFO_DATA,
        payload
    };
}

/**
 * Set marquee closed/open state for Click&Pledge
 * @param {boolean} payload - true if marquee is closed, false if open
 * @returns {Object}
 */
export function setMarqueeClosed(payload) {
    return {
        type: IS_MARQUEE_CLOSED,
        payload
    };
}

/**
 * Records a wallet-payment deep-link return so the open donation modal can
 * finalize the charge. The gateway approval round-trip (PayPal / Amazon Pay)
 * re-enters the app through the go.meethour.io:// custom scheme carrying a
 * `payment_oauth` marker. When that return escapes the in-app WebView and is
 * routed by the OS to the conference (appNavigate), we relay the full deep-link
 * URL here; {@code GiventDonateModal} observes it and feeds it to the wallet
 * WebView to complete the finalize step (mirroring the in-WebView interception).
 *
 * @param {string} url - The full go.meethour.io:// deep-link return URL.
 * @returns {Object}
 */
export function bindWalletPaymentReturn(url) {
    return {
        type: WALLET_PAYMENT_RETURN,
        payload: {
            url,
            ts: Date.now()
        }
    };
}

/**
 * Clear form-related API cache entries (formSettings, recurring, payment, convenienceFee).
 * Preserves registration cache so that the user does NOT re-register on refresh.
 */
export function clearFormApiCache() {
    return { type: CLEAR_FORM_API_CACHE };
}

/**
 * Displays the native/web prompt for entering Givent credentials.
 *
 * @param {Function} onPostSubmit - Optional callback invoked after successful submit.
 * @returns {Object}
 */
export function showEnterGiventPrompt(onPostSubmit: ?Function) {
    const { enterGiventPrompt } = require('./components');

    return openDialog(enterGiventPrompt, { onPostSubmit });
}

/**
 * Displays the native/web prompt for publishing and broadcasting Givent form.
 *
 * @param {Object} options - Publish prompt options.
 * @returns {Object}
 */
export function showGiventPublishPrompt(options: Object = {}) {
    const { giventPublishPrompt } = require('./components');

    return openDialog(giventPublishPrompt, options);
}

/**
 * Broadcasts Click&Pledge activation/removal and keeps local Redux state in sync.
 *
 * @param {string} value - Form GUID or the special value 'remove'.
 * @param {Object} streamOptions - Optional stream options payload.
 * @returns {Function}
 */
export function updateClickAndPledgeSession(value: string, streamOptions?: Object) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const conference = getCurrentConference(state);
        const localParticipantId = getLocalParticipant(state)?.id;
        const currentGiventId = state['features/clickandpledge']?.giventID || 0;
        const normalizedStreamOptions = normalizeStreamOptions(
            streamOptions || state['features/clickandpledge']?.streamOptions || DEFAULT_STREAM_OPTIONS
        );

        if (value === 'remove') {
            dispatch(bindFormGUID(''));
            dispatch(bindGiventID(0));
            dispatch(isClickandPledge(false));

            safeConferenceSendMessage(conference, {
                type: RESET_CLICKANDPLEDGE,
                myid: localParticipantId,
                senderId: localParticipantId
            }, 'clickandpledge-givent:updateClickAndPledgeSession:remove');

            return;
        }

        const formGuid = (value || '').trim();

        if (!formGuid) {
            return;
        }

        dispatch(bindFormGUID(formGuid));
        dispatch(bindStreamOptions(normalizedStreamOptions));
        dispatch(isClickandPledge(true));

        safeConferenceSendMessage(conference, {
            type: FORMGUID,
            clickandPledge: true,
            formGuid,
            streamOptions: normalizedStreamOptions,
            GiventID: currentGiventId
        }, 'clickandpledge-givent:updateClickAndPledgeSession:publish');
    };
}

